import axios from 'axios'
import config from '../config/dev.json'
import { refresh } from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/language'

import production from '../config/production.json'
if(process.env.NODE_ENV === 'production'){
  url = production.host + path + '/language'
}

export async function getAllLanguage() {
  return new Promise((resolve, reject) => {
    axios.get(url + '/all').then((response) => {
      let langs = response.data.data
      resolve(langs)
    }).catch(err => reject(err))
  })
}

export async function getLanguageById(id) {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/'+ id).then((response) => {
      let lang = response.data.data
      resolve(lang)
    }).catch(err => reject(err))
  })
}


// WEBPACK FOOTER //
// ./src/api/language.service.js